/**
 * Syncs the receivables overview carousel with current URL params.
 * Used by document-filter and forecast-toggle controllers.
 *
 * @param {import("@hotwired/stimulus").Application} application - Stimulus application instance
 * @param {URLSearchParams} params - Current URL search params
 */
export function syncReceivablesOverview(application, params) {
  const overviewElement = document.querySelector("[data-controller~='receivables-overview']")
  if (!overviewElement) return

  const controller = application.getControllerForElementAndIdentifier(overviewElement, "receivables-overview")
  controller?.syncOverview(params)
}
